const ACCESS_GEOLOCALISATION = 'ACCESS_GEOLOCALISATION';
const ACCESS_DASHBOARD = 'ACCESS_DASHBOARD';
const ACCESS_CAMPAIGNS = 'ACCESS_CAMPAIGNS';
const LINK_EXTERNAL_CAMPAIGNS = 'LINK_EXTERNAL_CAMPAIGNS';
const LINK_RUNNING_CAMPAIGN = 'LINK_RUNNING_CAMPAIGN';
const ACCESS_REACH = 'ACCESS_REACH';
const ACCESS_SALES = 'ACCESS_SALES';
const ACCESS_SALES_MANAGEMENT = 'ACCESS_SALES_MANAGEMENT';
const ACCESS_LISTENING_TIME = 'ACCESS_LISTENING_TIME';
const ACCESS_DEMOGRAPHY = 'ACCESS_DEMOGRAPHY';
const MANAGE_USERS = 'MANAGE_USERS';
const MANAGE_CAMPAIGNS = 'MANAGE_CAMPAIGNS';
const MANAGE_CUSTOMERS = 'MANAGE_CUSTOMERS';
const ACCESS_SPOTS = 'ACCESS_SPOTS';
const ACCESS_CONFIGURATION = 'ACCESS_CONFIGURATION';
const MANAGE_CAMPAIGNS_ADVERTISEMENT = 'MANAGE_CAMPAIGNS_ADVERTISEMENT';
const ACCESS_QUALITATIVE = 'ACCESS_QUALITATIVE';
const ACCESS_HISTORY = 'ACCESS_HISTORY';
const DELETE_CAMPAIGNS = 'DELETE_CAMPAIGNS';
const CREATE_DEMO_CAMPAIGN = 'CREATE_DEMO_CAMPAIGN';
const BILL_RADIOS = 'BILL_RADIOS';
const ACCESS_STREAMING = 'ACCESS_STREAMING';
const ACCESS_SALES_FLYER = 'ACCESS_SALES_FLYER';
const ACCESS_ALL_CAMPAIGNS = 'ACCESS_ALL_CAMPAIGNS';
const MANAGE_ALL_CUSTOMERS = 'MANAGE_ALL_CUSTOMERS';


export type Permission =
  | 'ACCESS_GEOLOCALISATION'
  | 'ACCESS_DASHBOARD'
  | 'ACCESS_CAMPAIGNS'
  | 'LINK_EXTERNAL_CAMPAIGNS'
  | 'LINK_RUNNING_CAMPAIGN'
  | 'ACCESS_REACH'
  | 'ACCESS_SALES'
  | ACCESS_SALES_FLYER
  | 'ACCESS_SALES_MANAGEMENT'
  | 'ACCESS_LISTENING_TIME'
  | 'ACCESS_DEMOGRAPHY'
  | 'MANAGE_USERS'
  | 'MANAGE_CAMPAIGNS'
  | 'MANAGE_CUSTOMERS'
  | 'ACCESS_SPOTS'
  | 'ACCESS_CONFIGURATION'
  | 'MANAGE_CAMPAIGNS_ADVERTISEMENT'
  | 'ACCESS_QUALITATIVE'
  | 'ACCESS_HISTORY'
  | 'DELETE_CAMPAIGNS'
  | 'BILL_RADIOS'
  | 'CREATE_DEMO_CAMPAIGN'
  | 'ACCESS_STREAMING'
  | 'ACCESS_ALL_CAMPAIGNS'
  | 'MANAGE_ALL_CUSTOMERS';

export default {
  ACCESS_GEOLOCALISATION,
  ACCESS_DASHBOARD,
  ACCESS_CAMPAIGNS,
  LINK_EXTERNAL_CAMPAIGNS,
  LINK_RUNNING_CAMPAIGN,
  ACCESS_REACH,
  ACCESS_SALES,
  ACCESS_SALES_FLYER,
  ACCESS_SALES_MANAGEMENT,
  ACCESS_LISTENING_TIME,
  ACCESS_DEMOGRAPHY,
  MANAGE_USERS,
  MANAGE_CAMPAIGNS,
  MANAGE_CUSTOMERS,
  ACCESS_SPOTS,
  ACCESS_CONFIGURATION,
  MANAGE_CAMPAIGNS_ADVERTISEMENT,
  ACCESS_QUALITATIVE,
  ACCESS_HISTORY,
  DELETE_CAMPAIGNS,
  CREATE_DEMO_CAMPAIGN,
  BILL_RADIOS,
  ACCESS_STREAMING,
  ACCESS_ALL_CAMPAIGNS,
  MANAGE_ALL_CUSTOMERS,
};



// WEBPACK FOOTER //
// ./src/statsradio/modules/authorisation/Permissions.js